export const experience = {
  it: {
    title: "Algoritmo Evolutivo",
    subtitle: "Non è un CV. È il log di installazione delle competenze che userò per scalare la tua azienda. Ogni esperienza ha aggiunto un modulo critico al mio stack.",
    impact: "SYSTEM IMPACT",
    modules: "INSTALLED MODULES",
    items: [
      {
        impact: "Architecture & Ops",
        company: "Varienda-BMS",
        role: "Founder & Chief Architect",
        period: "Sep 2025 - Present",
        description: "Ho fondato Varienda-BMS, il mio Studio di Architettura Operativa, per trasformare il caos operativo delle PMI in vantaggio competitivo. Come Fondatore e Architetto Capo, guido il mio \"Metodo\" (1. Diagnosi, 2. Architettura, 3. Iterazione) per implementare sistemi intelligenti che funzionano. Progetti principali: LAUNCH (presenza digitale autonoma) e VECTOR (Workflow OS).",
        achievements: [
          "LAUNCH: Layer per presenza digitale autonoma (Sito + CRM + AI)",
          "VECTOR: Workflow OS per unire flussi approvativi, dati e AI",
          "Missione: Portare l'efficienza dei colossi alle PMI italiane"
        ],
        techStack: "System Architecture, Process Analysis, +4 skills"
      },
      {
        impact: "-60% di Lavoro Manuale",
        company: "Baker Hughes",
        role: "Ingegnere del Software",
        period: "2023 - 2024",
        description: "Automatizzati processi aziendali critici per un leader globale dell'energia, riducendo drasticamente l'intervento manuale.",
        achievements: [
          "Progettato applicazioni di approvazione del flusso di lavoro con PowerApps e Power Automate",
          "Costruito dashboard Power BI avanzate per il processo decisionale esecutivo"
        ],
        techStack: "PowerApps, Power Automate, Power BI, SQL Server, Azure AI"
      },
      {
        impact: "+15% Efficienza Operativa",
        company: "Pharma Line Srl",
        role: "Sviluppatore Software",
        period: "2021 - 2023",
        description: "Guidato la trasformazione digitale, automatizzando la gestione delle vendite e dei flussi di lavoro di back-end.",
        achievements: [
          "Sviluppato applicazioni PowerApps per la gestione di vendite e ordini",
          "Costruito dashboard KPI in tempo reale per la business intelligence"
        ],
        techStack: "PowerApps, Power BI, SQL Server, PowerShell"
      },
      {
        impact: "Digitalizzazione Completa",
        company: "Angelica Wine Srls",
        role: "Programmatore",
        period: "2019 - 2020",
        description: "Gestito la trasformazione digitale end-to-end, dallo sviluppo e-commerce all'automazione logistica.",
        achievements: [
          "Costruito piattaforme e-commerce personalizzate e strumenti di automazione logistica",
          "Progettato soluzioni web per il tracciamento dell'inventario e della supply chain"
        ],
        techStack: "SQL, Python, Power BI, React.js"
      }
    ]
  },
  en: {
    title: "Evolutionary Algorithm",
    subtitle: "Not a CV. It's the installation log of the skills I'll use to scale your company. Each experience added a critical module to my stack.",
    impact: "SYSTEM IMPACT",
    modules: "INSTALLED MODULES",
    items: [
      {
        impact: "Architecture & Ops",
        company: "Varienda-BMS",
        role: "Founder & Chief Architect",
        period: "Sep 2025 - Present",
        description: "I founded Varienda-BMS, my Operational Architecture Studio, to transform SME operational chaos into competitive advantage. As Founder & Chief Architect, I lead my \"Method\" (1. Diagnosis, 2. Architecture, 3. Iteration) to implement intelligent systems that work. Main projects: LAUNCH (autonomous digital presence) and VECTOR (Workflow OS).",
        achievements: [
          "LAUNCH: Autonomous digital presence layer (Site + CRM + AI)",
          "VECTOR: Workflow OS uniting approval flows, data, and AI",
          "Mission: Bring enterprise-grade efficiency to Italian SMEs"
        ],
        techStack: "System Architecture, Process Analysis, +4 skills"
      },
      {
        impact: "-60% Manual Work",
        company: "Baker Hughes",
        role: "Software Engineer",
        period: "2023 - 2024",
        description: "Automated critical enterprise processes for a global energy leader, drastically reducing manual intervention.",
        achievements: [
          "Designed workflow approval applications using PowerApps & Power Automate",
          "Built advanced Power BI dashboards for executive decision-making"
        ],
        techStack: "PowerApps, Power Automate, Power BI, SQL Server, Azure AI"
      },
      {
        impact: "+15% Operational Efficiency",
        company: "Pharma Line Srl",
        role: "Software Developer",
        period: "2021 - 2023",
        description: "Led digital transformation, automating sales management and back-end workflows.",
        achievements: [
          "Developed PowerApps-based applications for sales & order management",
          "Built real-time KPI dashboards for business intelligence"
        ],
        techStack: "PowerApps, Power BI, SQL Server, PowerShell"
      },
      {
        impact: "End-to-End Digitization",
        company: "Angelica Wine Srls",
        role: "Programmer",
        period: "2019 - 2020",
        description: "Managed the end-to-end digital transformation, from e-commerce development to logistics automation.",
        achievements: [
          "Built custom e-commerce platforms & logistics automation tools",
          "Designed web-based inventory & supply chain tracking solutions"
        ],
        techStack: "SQL, Python, Power BI, React.js"
      }
    ]
  }
};